import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons/faBarcodeRead';

import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useIsVerified, useGetUserName, useGetVerifiedDateUtc } from '../../../../../../fulfillment-plans/scan-item-verification/hooks';
import { ScanItemVerificationTooltip } from '../../../../../../fulfillment-plans/scan-item-verification/verification-tooltip';

import messages from '../messages';
import style from '../shipment-items.module.less';

export const ShipmentVerification = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const userName = useGetUserName(fulfillmentPlanId);
  const isVerified = useIsVerified(fulfillmentPlanId);
  const verifiedUtc = useGetVerifiedDateUtc(fulfillmentPlanId);
  if (!isVerified) {
    return null;
  }

  return (
    <ScanItemVerificationTooltip className={style['verified-tooltip']} userName={userName} verifiedUtc={verifiedUtc}>
      <div className={style['verified-label']}>
        <FontAwesomeIcon className={style['verified-icon']} icon={faBarcodeRead} />
        <Text element='span' textType={TextType.Caption} value={messages.verified} />
      </div>
    </ScanItemVerificationTooltip>
  );
};
